import React from "react";
import StockoutEmployeePanel from './stockoutEmployeePanel.component';
import { useDispatch, useSelector } from "react-redux";
import { selectLoading } from "modules/notification";
import { useState } from "react";
import { useEffect } from "react";
import moment from "moment";
import { getDealerStockoutByEmployeeData } from "modules/reporting/redux";

export default function StockoutEmployeePanelContainer({
    currentFilter,
    urlDealerStockoutEmployee,
    pageType,
    translate
}){
    const dispatch = useDispatch();

    // (1) stockout employee data -- start
    const isFetchingDealerStockoutEmployee = useSelector(state => selectLoading(state, getDealerStockoutByEmployeeData.typePrefix));
    const dealerStockoutByEmployeeData = useSelector(state => state.reporting.stockout.dealer.stockoutByEmployeeData);
    // (1) stockout employee data -- end

    const [tableFilter, setTableFilter] = useState({
        page: 0,
        rowsPerPage: 10,
        search: "",
        searchBy: "name",
        orderBy: "stockout_count",
        orderDirection: "desc",
    });

    useEffect(() => {
        dispatch(getDealerStockoutByEmployeeData({
            length: tableFilter.rowsPerPage,
            start: tableFilter.page * tableFilter.rowsPerPage,
            orderBy: tableFilter.orderBy,
            orderDirection: tableFilter.orderDirection,
            search: tableFilter.search,
            searchBy: tableFilter.searchBy,
            branch_uuid: currentFilter.branchUuid,
            category_uuid: currentFilter.categoryUuid,
            brand_uuid: currentFilter.brandUuid,
            model_uuid: currentFilter.modelUuid,
            product_uuid: currentFilter.productUuid,
            period: currentFilter.period,
            start_date: moment(currentFilter.dateRange[0]).format('YYYY-MM-DD'),
            end_date: moment(currentFilter.dateRange[1]).format('YYYY-MM-DD'),
            url: urlDealerStockoutEmployee
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, tableFilter, currentFilter]);

    const handleChangePage = (e, newPage) => {
        setTableFilter((prev) => ({
          ...prev,
          page: newPage,
        }))
    }

    const handleChangeRowPerPage = (event) => {
        setTableFilter((prev) => ({
          ...prev,
          page: 0,
          rowsPerPage: event.target.value
        }))
    }

    const handleRequestSort = (event, property) => {
        const isAsc = tableFilter.orderBy === property && tableFilter.orderDirection === 'asc';
        setTableFilter((prev) => ({
            ...prev,
            orderDirection: isAsc ? 'desc' : 'asc',
            orderBy: property,
        }))
    }

    return (
        <StockoutEmployeePanel 
            status={{
                isFetchingDealerStockoutEmployee
            }}

            data={{
                dealerStockoutByEmployeeData
            }}

            sort={{
                valueToOrderBy: tableFilter.orderBy,
                orderDirection: tableFilter.orderDirection,
                handleRequestSort: handleRequestSort,
            }}

            pagination={{
                handleChangePage: handleChangePage,
                handleChangeRowPerPage: handleChangeRowPerPage,
                page: tableFilter.page,
                rowsPerPage: tableFilter.rowsPerPage,
                rowsPerPageOptions: [5, 10, 25],
            }}

            currentFilter={currentFilter}

            translate={translate}

            pageType={pageType}
        />
    )
}